<template>
  <div class="amendsite">
    <!--头部-->
    <GlobTopNav title="编辑地址"></GlobTopNav>

    <div class="van-content">
      <van-cell-group>
        <van-field v-model="name" placeholder="请输入收货人" label="收货人" />
        <van-field
          v-model="mobile"
          placeholder="为避免影响收货，请准确填写您的手机号！"
          label="手机号码"
        />
        <!-- <van-field v-model="postnum" placeholder="请输入邮政编码" label="邮政编码" /> -->
        <van-field
          v-model="sitedDatasName"
          placeholder="选择地址"
          readonly
          label="省市区"
          @click="cityPickerShow"
        />
        <van-field v-model="setess" placeholder label="详细地址" />
        <van-cell title="设为默认地址">
          <van-switch v-model="checked" size="24" active-color="rgba(227, 51, 49, 1)" />
        </van-cell>
      </van-cell-group>
      <div class="addSiteBtn-all">
        <van-button size="large" class="addSiteBtn clearBtn radius6" @click="delDatas">
          删除
        </van-button>
        <van-button size="large" class="addSiteBtn" @click="sendDatas">
          保存
        </van-button>
      </div>
    </div>
    <!--地址选择弹框-->
    <!-- <city-picker ref="cityPicker" @confirm="confirm"></city-picker> -->
    <city-picker ref="cityPicker" @listenSitedata="geSitedatas"></city-picker>
  </div>
</template>

<script>
import CityPicker from "@/pages/user/mysite/cityPicker";
export default {
  name: "addsite",
  components: {
    CityPicker
  },
  data() {
    return {
      siteId: this.$route.query.id,
      sitedDatas: "",
      sitedDatasName: "",
      checked: false, //设为默认
      name: "", //收货人
      mobile: "", //手机号
      site: "", //省市区
      setess: "", //详细地址
      province: "",
      city: "",
      town: "",
      county: "",
      postnum: "",
      provincename: "",
      cityname: "",
      townname: "",
      countyname: "",
      len: ""
    };
  },
  methods: {
    cityPickerShow() {
      // this.$refs.cityPicker.setSiteShow(true);
      this.$refs.cityPicker.setSiteShow(true);
    },
    // confirm(data) {
    //   var area = "";
    //   // this.site=''
    //   this.siteid = [];
    //   this.sitename = [];
    //   data.forEach(item => {
    //     if (item) {
    //       area += item.name + "-";
    //       this.siteid.push(item.id);
    //       this.sitename.push(item.name);
    //     }
    //   });

    //   this.provincename= this.sitename[0];
    //   this.cityname= this.sitename[1];
    //   this.townname= this.sitename[2];
    //   this.countyname= this.sitename[3] ? this.sitename[3] : '';

    //   this.province = this.siteid[0];
    //   this.city = this.siteid[1];
    //   this.town = this.siteid[2];
    //   this.county = this.siteid[3] ? this.siteid[3] : 0;
    //   area = area.substr(0, area.length - 1); //地址
    //   this.$refs.cityPicker.setSiteShow(false);
    //   this.sitedDatasName = area;
    // },
    geSitedatas(datas) {
      this.sitedDatasName = "";
      this.sitedDatas = datas;
      if (datas[0].id != undefined) {
        this.sitedDatasName += datas[0].name;
        this.province = datas[0].id;
        this.provincename = datas[0].name;
      }
      if (datas[1].id != undefined) {
        this.sitedDatasName += " " + datas[1].name;
        this.city = datas[1].id;
        this.cityname = datas[1].name;
      }
      if (datas[2].id != undefined) {
        this.sitedDatasName += " " + datas[2].name;
        this.county = datas[2].id;
        this.countyname = datas[2].name;
      }
      if (datas[3].id != undefined) {
        this.sitedDatasName += " " + datas[3].name;
        this.town = datas[3].id;
        this.townname = datas[3].name;
      } else {
        this.town = 0;
        this.townname = "";
      }
    },
    goBack: function() {
      history.back(-1);
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$api.post(
        "user/address/userinfo",
        { id_example: mallid, token_user: isUser, address_id: this.siteId },
        res => {
          if (res.data.code == "100") {
            this.name = res.data.data.name;
            this.mobile = res.data.data.phone;
            if (res.data.data.town_str == "") {
              this.sitedDatasName =
                res.data.data.province_str +
                "-" +
                res.data.data.city_str +
                "-" +
                res.data.data.county_str;
            } else {
              this.sitedDatasName =
                res.data.data.province_str +
                "-" +
                res.data.data.city_str +
                "-" +
                res.data.data.county_str +
                "-" +
                res.data.data.town_str;
            }
            this.setess = res.data.data.address;
            this.province = res.data.data.province;
            this.city = res.data.data.city;
            this.town = res.data.data.town;
            this.county = res.data.data.county;
            this.postnum = res.data.data.zip;
            this.provincename = res.data.data.province_str;
            this.cityname = res.data.data.city_str;
            this.townname = res.data.data.town_str;
            this.countyname = res.data.data.county_str;
            res.data.data.default == 1
              ? (this.checked = true)
              : (this.checked = false);
          } else {
            this.$toast(res.data.message);
          }
        }
      );
    },
    sendDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      var moren = 0;
      if (this.checked == true) {
        moren = 1;
      } else {
        moren = 0;
      }
      this.len = 0;
      this.getByteLen(this.name);
      var reg = /^[1][3456789][0-9]{9}$/;
      //判断收货人
      if (this.name == "") {
        this.btn = false;
        this.$toast("请输入收货人");
        return;
      }
      //判断收货人姓名长度
      if (this.len > 24) {
        this.btn = false;
        this.$toast("收货人姓名必须小于24个字符！");
        return;
      }
      //判断手机号
      if (!reg.test(this.mobile)) {
        this.btn = false;
        this.$toast("请输入正确的手机号！");
        return;
      }
      //判断地址
      if (this.provincename == "") {
        this.btn = false;
        this.$toast("请填写完整地址");
        return false;
      }
      if (this.countyname == "请选择") {
        this.$toast("请填写完整地址");
        return false;
      }
      this.$api.post(
        "user/address/update",
        {
          id_example: mallid,
          token_user: isUser,
          id_address: this.siteId,
          default: moren,
          name: this.name,
          phone: this.mobile,
          address: this.setess,
          zip: this.postcode,
          province: this.province,
          city: this.city,
          town: this.town,
          county: this.county,
          province_str: this.provincename,
          city_str: this.cityname,
          town_str: this.townname,
          county_str: this.countyname,
          zip: this.postnum
        },
        res => {
          if (res.data.code == "100") {
            this.goBack();
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    },
    getByteLen: function(val) {
      //限制24个字符
      var _this = this;
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
          _this.len += 2;
        } else {
          _this.len += 1;
        }
      }
      return _this.len;
    },
    delDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      var moren = 0;
      if (this.checked == true) {
        moren = 1;
      } else {
        moren = 0;
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除此收货地址吗？"
        })
        .then(() => {
          this.$api.post(
            "user/address/delete",
            { id_example: mallid, token_user: isUser, id_address: this.siteId },
            res => {
              if (res.data.code == "100") {
                history.back(-1);
              } else {
                this.$toast({
                  message: res.data.message,
                  duration: 500
                });
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less">
.amendsite {
  min-height: 100vh;
  background-color: #f5f5f5;
  .van-cell-group {
    background-color: #fff;
  }

  .van-cell {
    padding: 0.3rem 0.36rem;

    .van-cell__title {
      font-size: 0.28rem;
      font-weight: bold;
      color: rgba(38, 38, 38, 0.8);
      line-height: 0.48rem;
    }
  }

  .addSiteBtn-all {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    margin-top: 1rem;

    .addSiteBtn {
      width: 3.2rem;
      height: 0.96rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      color: #fff;
    }

    .clearBtn {
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 0.02rem solid #e23331;
      color: rgba(226, 51, 49, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/amendsite.vue